import { render } from "./innerImageInfo.vue?vue&type=template&id=0521c54e&scoped=true"
import script from "./innerImageInfo.vue?vue&type=script&lang=js"
export * from "./innerImageInfo.vue?vue&type=script&lang=js"

import "./innerImageInfo.vue?vue&type=style&index=0&id=0521c54e&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-0521c54e"

export default script